export interface RoleInterface {
  ROLE_SUPER_ADMIN: string;
  ROLE_ADMIN: string;
  ROLE_SWIMMING_LESSON_PROVIDER_MANAGER: string;
  ROLE_SWIMMING_LESSON_PROVIDER_USER: string;
  ROLE_LESSON_LOCATION_USER: string;
  ROLE_EXAMINER: string;
  ROLE_DELEGATE: string;
  ROLE_OPERATOR_USER: string;
}

export type AdminRole = 'ROLE_SUPER_ADMIN' | 'ROLE_ADMIN';

const Roles: RoleInterface = {
  ROLE_SUPER_ADMIN: 'Superadmin',
  ROLE_ADMIN: 'Admin',
  ROLE_SWIMMING_LESSON_PROVIDER_MANAGER: 'Zwemlesaanbieder beheerder',
  ROLE_SWIMMING_LESSON_PROVIDER_USER: 'Zwemlesaanbieder gebruiker',
  ROLE_LESSON_LOCATION_USER: 'Locatiemedewerker',
  ROLE_EXAMINER: 'Examinator',
  ROLE_DELEGATE: 'Gedelegeerde',
  ROLE_OPERATOR_USER: 'Exploitant Gebruiker',
};

export default Roles;
